<template>
    <mu-select-field label="选择框" value="index">
        <mu-menu-item value="index" title="选择框" />
    </mu-select-field>
</template>
<script>
export default {
    name: 'selectField'
}
</script>



// WEBPACK FOOTER //
// selectField.vue?5300fdce